import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = 'https://api.civilcadpro.in/api';

function Customers() {
  const [customers, setCustomers] = useState([]);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API_URL}/customers`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCustomers(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async (e) => {
    setSearch(e.target.value);
    if (e.target.value.length < 2) {
      fetchCustomers();
      return;
    }
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API_URL}/customers/search?q=${e.target.value}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCustomers(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  // Filter customers based on subscription status
  const getFilteredCustomers = () => {
    return customers.filter(cust => {
      if (filter === 'all') return true;
      if (filter === 'active') return cust.activeLicenses > 0;
      if (filter === 'expired') return cust.activeLicenses === 0;
      if (filter === 'company') return cust.type === 'company';
      if (filter === 'individual') return cust.type === 'individual';
      return true;
    });
  };

  const filteredCustomers = getFilteredCustomers();

  if (loading) return <div className="card">Loading...</div>;

  return (
    <div>
      <h2 style={{ marginBottom: 25, color: '#1a1a2e' }}>Customers</h2>
      
      <div className="card">
        {/* Search & Filter Row */}
        <div style={{ display: 'flex', gap: 15, marginBottom: 20, flexWrap: 'wrap' }}>
          <input
            type="text"
            placeholder="Search customers by name, email, or company..."
            value={search}
            onChange={handleSearch}
            style={{
              flex: 1,
              minWidth: 250,
              padding: '12px 15px',
              border: '1px solid #ddd',
              borderRadius: 6,
              fontSize: 14
            }}
          />
          
          <select
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            style={{
              padding: '12px 15px',
              border: '1px solid #ddd',
              borderRadius: 6,
              fontSize: 14,
              background: 'white',
              cursor: 'pointer',
              minWidth: 150
            }}
          >
            <option value="all">All Customers</option>
            <option value="active">🟢 Active</option>
            <option value="expired">🔴 Expired</option>
            <option value="company">🏢 Company</option>
            <option value="individual">👤 Individual</option>
          </select>
        </div>

        {/* Stats Row */}
        <div style={{ 
          display: 'flex', gap: 15, marginBottom: 20, 
          padding: '12px 15px', background: '#f8f9fa', borderRadius: 8 
        }}>
          <span style={{ fontSize: 13, color: '#666' }}>
            Total: <strong>{customers.length}</strong>
          </span>
          <span style={{ fontSize: 13, color: '#2ea043' }}>
            Active: <strong>{customers.filter(c => c.activeLicenses > 0).length}</strong>
          </span>
          <span style={{ fontSize: 13, color: '#dc3545' }}>
            Expired: <strong>{customers.filter(c => c.activeLicenses === 0).length}</strong>
          </span>
          <span style={{ fontSize: 13, color: '#666' }}>
            Showing: <strong>{filteredCustomers.length}</strong>
          </span>
        </div>
        
        {filteredCustomers.length === 0 ? (
          <p style={{ textAlign: 'center', color: '#888', padding: 40 }}>No customers found</p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Customer ID</th>
                <th>Name</th>
                <th>Type</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Total Licenses</th>
                <th>Active</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {filteredCustomers.map(cust => (
                <tr key={cust._id}>
                  <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{cust.customerId}</td>
                  <td><strong>{cust.name}</strong></td>
                  <td>
                    {cust.type === 'company' ? '🏢 Company' : '👤 Individual'}
                  </td>
                  <td>{cust.email}</td>
                  <td>{cust.phone || '-'}</td>
                  <td>{cust.totalLicenses}</td>
                  <td>
                    <span className="status-badge status-approved">{cust.activeLicenses}</span>
                  </td>
                  <td>
                    {cust.activeLicenses > 0 ? (
                      <span className="status-badge status-approved">Active</span>
                    ) : (
                      <span className="status-badge status-rejected">Expired</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default Customers;